<template>
  <div class="row">
    <div :class="listStyle">
      <List
        :__list="dataArray"
        :__isOnLoad="isListOnload"
        :__editMode="this.onEditionId != null"
        :__idxOnEdition="this.onEditionIdx"
        :public-page-slug="publicPageSlug"
        :catalog-mode="catalogMode"
        :is-admin="isAdmin"
        ></List>
    </div>
  </div>
</template>
<script>
import {SuperAdminRouter, AgentRouter, ClientRouter} from "@/router/initRouter";
import Vue from "vue";
import List from './List';
export default {
  components: {
    List,
  },
  props: {
    isAdmin:  {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    publicPageSlug: {
      type: String,
      default: () => {
        return null;
      },
    },
    catalogMode: {
      type: String,
      default: () => {
        return null;
      },
    },
  },

  data() {
    return {
      moduleRoute: '/prods',
      onEditionId: null,
      onEditionIdx: -1,
      onEditionItem: null,
      isListOnload: false,
      isEditOnload: false,
      dataArray: [],
      onGoingReq:[],
    };
  },

  computed: {
    listStyle() {
      return this.onEditionId !== null ? 'col-md-6' : 'col-md-12';
    },
  },

  methods: {
    isPublicStaticPage() {
      return !this.isAdmin && !!this.publicPageSlug;
    },

    isPublicExperience() {
      return !this.isAdmin && (!!this.publicPageSlug || this.$route.path === '/catalogue');
    },

    getModuleRouteByCatalogMode() {
      return this.catalogMode === 'SRV' ? '/services' : '/prods';
    },

    cancelAction() {
      this.onEditionId = null;
      this.onEditionIdx = -1;
      this.onEditionItem = null;
    },

    updPriceAction(itm) {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(itm._id, null, -1);
      };
      
      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      var data = {
        _id: itm._id,
        prixV: itm.newPrice
      }
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    saveAction() {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(this.onEditionId, null, this.onEditionIdx);
      };
      
      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      let diff = this.__.differ(
        this.dataArray[this.onEditionIdx],
        this.onEditionItem
      );
      diff.push('_id');
      let data = this._.pick(this.onEditionItem, diff);
      
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    toggleActivateAction(id, val) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx].isActive = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', 'isActive']);
      data.isActive = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    editAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx)
      this.onEditionId = id;
      this.onEditionIdx = idx;
      this.onEditionItem = this._.omit(this.dataArray[idx]);
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    addAction() {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(response.data, () =>
          this.editAction(response.data)
        );
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      this.__.httpAction({
        methode: 'PUT',
        route: this.moduleRoute,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    loadData(id = null, cb = null, putAt = null) {
      let $onNext = (response) => {
        if (id != null) {
          if (putAt != null) {
            if(putAt === -1) {
              const idx = (element) => element._id === id;
              var position = this.dataArray.findIndex(idx)
              console.log(position );
              this.dataArray[position] = response.data[0];
            } else {
              this.dataArray[putAt] = response.data[0];
            }
            
          } else {
            this.dataArray.unshift(response.data[0]);
          }

          if (cb) cb();
        } else {
          this.dataArray = response.data;
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: this.moduleRoute+ (id != null ? '/'+id : '/'),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    getExercice() {
      let $onNext = (response) => {
        var ex = response.data
        if(ex.length> 0) {
          Vue.$cookies.set('exercice',ex[0].name);
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: '/opts/list/6784308adefa389903ad4ea4',
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },


    checkAndGo(){
      if (this.isPublicStaticPage()) {
        return
      }

      this.moduleRoute = this.getModuleRouteByCatalogMode();
      const adminGuest = Vue.$cookies.get("user");
      const exercice = Vue.$cookies.get("exercice");

      if(!exercice) {
        this.getExercice()
      }

      if(adminGuest) {
        this.addRouterAndGo(adminGuest)
      } else {
        this.loadData()
      }
    },

    addRouterAndGo(admin) {
      if(["ADMIN", "ROOT", "COMMERCIAL", "TECHNIQUE", "MAGASINIER"].includes(admin.type)) {
        if (this.isPublicExperience()) {
          if (!this.isPublicStaticPage()) {
            this.loadData()
          }
          return
        }

        if(this.$props.isAdmin) {
          this.loadData()
        return
        } else {
          this.$router.addRoute(SuperAdminRouter);
          this.$router.push('/superadmin')
          return
        }
      }

      if(admin.type === "CLIENT") {
        this.$router.addRoute(ClientRouter);
        this.loadData()
        return
      }
      if(admin.type === "GUEST") {
        this.__.httpAction({
          methode: 'GET',
          route: '/admins/by/'+admin.ID,
          data: {},
          onNext: (response) => {
            if(response.data.length === 1 && response.data[0].isActive === true) {
              Vue.$cookies.remove("user")
              this.$router.push('/authentification')  
              
            } else {
              this.loadData()
            }
          },
          onError: ()=> {},
          onComplete: ()=> {},
        });
         
        return
      }
      this.loadData()
    },

    
  },
  mounted() {
    //Vue.$cookies.remove("user")
    this.checkAndGo();
  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
  },
};
</script>
<style></style>
